// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Triggers.css */

/* Main Trigger Container */
.email-trigger-container,
.linked-task-trigger-container,
.file-path-trigger-container,
.trigger-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* No absolute positioning */
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
  max-width: 600px;
  width: 100%;
  margin: 20px auto; /* Center horizontally and add top margin */
}


/* Add space between Breadcrumbs and Trigger */
.breadcrumbs + .trigger-container {
  margin-top: 20px;
}

h2 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  width: 100%;
  margin-bottom: 8px;
}

.form-group button {
  padding: 7px 7px;
  margin-top: 6px;
  margin-bottom: 10px;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
  transition: #5bca3f 0.3s ease;
}

.form-group label {
  display: block;
  font-size: 16px;
  margin-bottom: 5px;
  margin-top: 6px;
  color: #555;
}

/* burada yer aliyor condition kismi  */
.form-group select
{
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
  margin-bottom: 5px;
}


.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
  margin-bottom: 0px;
  
}

.form-group select:focus,
.form-group input:focus {
  border-color: #305e7a;
  outline: none;
}

/* Buttons */
button {
  padding: 10px 20px;
  margin-top: 20px;
  background-color: #305e7a;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #0056b3;
}


.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
}

.checkbox-group input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
}

.input-tooltip {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.error-input {
  border-color: #ff4444;
}

.form-group input.error {
  border: 1px solid #ff4d4d;
  background-color: #fff8f8;
}

.error-message {
  color: #ff4d4d;
  font-size: 0.875rem;
  margin-top: 4px;
  display: block;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  position: relative;
  opacity: 0.7;
}

.form-group button.loading::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  top: 50%;
  left: 50%;
  margin-top: -8px;
  margin-left: -8px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error-text {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}

input.error, select.error {
  border-color: #dc3545;
}

input.error:focus, select.error:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.submit-error {
  background-color: #fff8f8;
  border: 1px solid #ff4d4d;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.space
{
  gap: 30px;
}


.form-group select option {
    padding: 8px;
    font-family: monospace;
}

.form-group select option[value="Critical"] {
    color: #dc3545;
}

.form-group select option[value="Highest"],
.form-group select option[value="Very high"] {
    color: #ff6b6b;
}

.form-group select option[value="High"],
.form-group select option[value="Medium-high"] {
    color: #ffa94d;
}

.form-group select option[value="Medium"],
.form-group select option[value="Medium-low"] {
    color: #51cf66;
}

.form-group select option[value="Low"],
.form-group select option[value="Very low"],
.form-group select option[value="Lowest"] {
    color: #339af0;
}

.form-group select option[value="Inherited"] {
    color: #868e96;
}
.process-robot-lock {
  margin-top: -10px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.robot-lock-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.robot-lock-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
  color: #495057;
}

.lock-icon {
  font-size: 14px;
}

.help-text {
  margin-top: 4px;
  margin-left: 24px;
  font-size: 12px;
  color: #6c757d;
}

.help-text.warning {
  color: #dc3545;
}

#stickToRobot {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

#stickToRobot:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 13px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
  resize: vertical;
  min-height: 90px; 
  margin-bottom: 5px;
}

.hint-text {
  display: block;
  font-size: 12px;        
  color: #888888;         
  margin-top: 4px;
  margin-bottom: 15px;
  font-style: italic;    
}
`, "",{"version":3,"sources":["webpack://./src/styles/Triggers.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB,2BAA2B;AAC3B;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B,EAAE,4BAA4B;EACzD,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,WAAW;EACX,iBAAiB,EAAE,2CAA2C;AAChE;;;AAGA,8CAA8C;AAC9C;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,uCAAuC;AACvC;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;;AAEpB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;AACX;;;AAGA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* Triggers.css */\n\n/* Main Trigger Container */\n.email-trigger-container,\n.linked-task-trigger-container,\n.file-path-trigger-container,\n.trigger-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start; /* No absolute positioning */\n  padding: 20px;\n  background-color: #f5f5f5;\n  border-radius: 10px;\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n  max-width: 600px;\n  width: 100%;\n  margin: 20px auto; /* Center horizontally and add top margin */\n}\n\n\n/* Add space between Breadcrumbs and Trigger */\n.breadcrumbs + .trigger-container {\n  margin-top: 20px;\n}\n\nh2 {\n  font-size: 24px;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.form-group {\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.form-group button {\n  padding: 7px 7px;\n  margin-top: 6px;\n  margin-bottom: 10px;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: #5bca3f 0.3s ease;\n}\n\n.form-group label {\n  display: block;\n  font-size: 16px;\n  margin-bottom: 5px;\n  margin-top: 6px;\n  color: #555;\n}\n\n/* burada yer aliyor condition kismi  */\n.form-group select\n{\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  margin-bottom: 5px;\n}\n\n\n.form-group input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  margin-bottom: 0px;\n  \n}\n\n.form-group select:focus,\n.form-group input:focus {\n  border-color: #305e7a;\n  outline: none;\n}\n\n/* Buttons */\nbutton {\n  padding: 10px 20px;\n  margin-top: 20px;\n  background-color: #305e7a;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\n\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px 0;\n}\n\n.checkbox-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n}\n\n.input-tooltip {\n  font-size: 12px;\n  color: #666;\n  margin-top: 4px;\n}\n\n.error-input {\n  border-color: #ff4444;\n}\n\n.form-group input.error {\n  border: 1px solid #ff4d4d;\n  background-color: #fff8f8;\n}\n\n.error-message {\n  color: #ff4d4d;\n  font-size: 0.875rem;\n  margin-top: 4px;\n  display: block;\n}\n\nbutton:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n  position: relative;\n  opacity: 0.7;\n}\n\n.form-group button.loading::after {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  top: 50%;\n  left: 50%;\n  margin-top: -8px;\n  margin-left: -8px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: #fff;\n  animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n  display: block;\n}\n\ninput.error, select.error {\n  border-color: #dc3545;\n}\n\ninput.error:focus, select.error:focus {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.submit-error {\n  background-color: #fff8f8;\n  border: 1px solid #ff4d4d;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n.space\n{\n  gap: 30px;\n}\n\n\n.form-group select option {\n    padding: 8px;\n    font-family: monospace;\n}\n\n.form-group select option[value=\"Critical\"] {\n    color: #dc3545;\n}\n\n.form-group select option[value=\"Highest\"],\n.form-group select option[value=\"Very high\"] {\n    color: #ff6b6b;\n}\n\n.form-group select option[value=\"High\"],\n.form-group select option[value=\"Medium-high\"] {\n    color: #ffa94d;\n}\n\n.form-group select option[value=\"Medium\"],\n.form-group select option[value=\"Medium-low\"] {\n    color: #51cf66;\n}\n\n.form-group select option[value=\"Low\"],\n.form-group select option[value=\"Very low\"],\n.form-group select option[value=\"Lowest\"] {\n    color: #339af0;\n}\n\n.form-group select option[value=\"Inherited\"] {\n    color: #868e96;\n}\n.process-robot-lock {\n  margin-top: -10px;\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #e9ecef;\n}\n\n.robot-lock-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.robot-lock-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #495057;\n}\n\n.lock-icon {\n  font-size: 14px;\n}\n\n.help-text {\n  margin-top: 4px;\n  margin-left: 24px;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.help-text.warning {\n  color: #dc3545;\n}\n\n#stickToRobot {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n#stickToRobot:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 13px;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  resize: vertical;\n  min-height: 90px; \n  margin-bottom: 5px;\n}\n\n.hint-text {\n  display: block;\n  font-size: 12px;        \n  color: #888888;         \n  margin-top: 4px;\n  margin-bottom: 15px;\n  font-style: italic;    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
